module.exports = __webpack_public_path__ + "img/ethiopia.1dc4ad76.png";